function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#trustyou_svg__clip0_1_109)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.364 13.09h8.727V0H0v16l4.364-2.91z",
  fill: "#F14854"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.818 13.09h8.727V0h-13.09v16l4.363-2.91z",
  fill: "#ECB400"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.273 13.09H48V0H34.91v16l4.363-2.91z",
  fill: "#78E448"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "trustyou_svg__clip0_1_109"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h48v16H0z"
})));

function SvgTrustyou(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgTrustyou;